import { Notes, Notes_Filter } from 'src/graphql/schema.graphql';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const userNotesGqlQuery: GqlFragment<
  { notes: Notes[] },
  { filters: Notes_Filter }
> = gql`
  query UserNotesQuery($filters: notes_filter) {
    notes(filter: $filters, sort: ["-date_created"]) {
      id
      content
      date_created
      targetId
      targetCollection
    }
  }
`;
